import { getRequest } from 'sync/request';
import { Flags } from 'utils/flags';

export function listFlags(organizationId: string = '') {
  return getRequest<Flags>(`/v2/features${organizationId ? `/${organizationId}` : ''}/flags`);
}
